<template>
  <div class="page-login-inner">
    <div class="login-logo">
      <img src="@img/signal-logo.svg" alt="signal logo" />
    </div>
    <form @submit.prevent="submit" class="login-form-box">
      <p class="text-center mb-4 font-12">
        ورود به حساب کاربری
      </p>
      <div class="el-input el-input--suffix">
        <input
          v-model="form.mobile"
          v-focus
          v-number.numeric
          v-validate="'required|numeric|mobile-no-zero'"
          type="tel"
          data-vv-as="شماره موبایل"
          placeholder="شماره موبایل"
          name="mobile"
          maxlength="11"
          class="el-input__inner force-ltr"
          style="direction:ltr;text-align:right"
          autocomplete="off"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon el-icon-mobile-phone" />
          </span>
        </span>
      </div>
      <div class="el-input el-input--suffix mt-2">
        <input
          v-model="form.password"
          type="password"
          v-validate="'required'"
          data-vv-as="رمز کاربری"
          placeholder="رمز کاربری"
          name="password"
          class="el-input__inner force-ltr"
          style="direction:ltr;text-align:right"
          autocomplete="off"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon el-icon-lock" />
          </span>
        </span>
      </div>
      <div class="text-center mt-4">
        <button class="submit-btn font-11" type="submit">
          ورود
        </button>
      </div>
      <div class="text-center mt-4">
        <router-link to="/forget-password">
          <p class="forgot-text">
            رمز عبور خود را فراموش کرده ام
          </p>
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import '@/assets/sass/pages/login.scss'
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        mobile: '',
        password: '',
        client: 'WEB'
      }
    }
  },
  computed: {
    ref() {
      let ref = this.$route.query.ref || ''
      if (!ref || ref.includes('404')) ref = { name: 'home' }
      return ref
    }
  },
  methods: {
    submit() {
      this.$validate().then(() => {
        let data = this.$clone(this.form)
        data.mobile = data.mobile.noZero()
        this.$store.commit('updateLoading', true)
        this.$store
          .dispatch('auth/signIn', {
            $vm: this,
            $client: 'user',
            variables: data
          })
          .then(res => {
            this.$user.reset()
            let authToken = res.data.signIn.authToken
            let result = res.data.signIn.result
            if (result && authToken) {
              this.$store.dispatch('auth/setToken', authToken).then(() => {
                this.$message.success('با موفقیت وارد شدید')
                this.$router.replace(this.ref)
              })
            } else if (result && !authToken) {
              this.$message.error('اطلاعات وارد شده صحیح نیست')
            }
          })
          .finally(() => this.$store.commit('updateLoading', false))
      })
    }
  }
}
</script>
